import { TextFieldProps as MuiTextFieldProps } from '@mui/material';
import { TextField } from 'components/TextField/TextField';
import React from 'react';

type NumericFieldProps = MuiTextFieldProps & {
  id: string;
};

export const NumericField = ({
  variant = 'outlined',
  value,
  placeholder,
  onChange,
  slotProps,
  ...props
}: NumericFieldProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const numericValue = inputValue.replace(/\D/g, '');
    const numericEvent = { ...event, target: { ...event.target, value: numericValue } };
    onChange?.(numericEvent);
  };

  return (
    <TextField
      variant={variant}
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      slotProps={{
        ...slotProps,
        htmlInput: { ...slotProps?.htmlInput, inputMode: 'numeric' }, // Force numeric input
      }}
      {...props}
    />
  );
};
